var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFintooNextIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #042b62;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M553.96,91c-247.8,0-448.69,200.88-448.69,448.69s200.88,448.7,448.69,448.7,448.7-200.89,448.7-448.7c-.28-247.69-201-448.41-448.7-448.69ZM553.96,943.51c-223.03,0-403.82-180.8-403.82-403.82s180.8-403.82,403.82-403.82,403.82,180.8,403.82,403.82c-.25,222.92-180.9,403.57-403.82,403.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.43,365.76c-9.33-8.16-23.51-7.21-31.66,2.12-8.15,9.33-7.2,23.51,2.13,31.66l160.17,140.14-160.18,140.15c-9.33,8.16-10.28,22.33-2.13,31.66,8.16,9.33,22.33,10.29,31.66,2.13l179.47-157.04c4.87-4.26,7.67-10.42,7.67-16.89s-2.79-12.63-7.67-16.89l-179.47-157.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFintooNextIc);
export default __webpack_public_path__ + "static/media/fintooNextIc.50b7338a9f4d86c334d2941eecbbd9dc.svg";
export { ForwardRef as ReactComponent };